import React from "react";
import { getAsset } from "../utilities/assets.utils";

export const PluginIntro = () => {
	return (
		<div className="mb-4">
			<a href="https://hootboard.com">
				<img
					src={getAsset("hootboard-logo.png")}
					alt="HootBoard"
					className="w-40"
				/>
			</a>
			<div className="text-2xl font-semibold  mb-4 mt-2 leading-8">
				Looking for a better way to communicate with your audience?
			</div>
			<div className="text-xl mb-12 leading-7">
				HootBoard is your modern bulletin board for your organization
				that works right inside of your website.
			</div>
			<div className="px-8">
				<img src={getAsset("intro.png")} alt="" className="w-full" />
			</div>
		</div>
	);
};
